import React from 'react';
import { t } from 'Src/i18n';
import { transformMinutesInHours } from 'Components/widgets/transport-details/transportUtils';
import { useResponsive } from 'Components/utils/responsive/ResponsiveContext';
import {
  getTotalDifferentialPrice,
  getTransportAverageDuration,
} from 'Utils/transport/transportUtils';
import { AdditionalTransportListOrderButton } from './AdditionalTransportListOrderButton';
type AdditionalTransportListFiltersProps = {
  totalTransports: number;
  cheapestTransport: AlternativeTransport;
  fastestTransport: AlternativeTransport;
  selectedOrder: 'cheapest' | 'fastest';
  setSelectedOrder: (order: 'cheapest' | 'fastest') => void;
};
export const AdditionalTransportListFilters = ({
  totalTransports,
  cheapestTransport,
  fastestTransport,
  selectedOrder,
  setSelectedOrder,
}: AdditionalTransportListFiltersProps) => {
  const { isRTL } = useResponsive();
  const isDisabled = totalTransports <= 1;
  const cheapestTransportTime = getTransportAverageDuration(cheapestTransport);
  const fastestTransportTime = getTransportAverageDuration(fastestTransport);
  return (
    <div className="my-20">
      <div data-testid="AdditionalTransportListFilters" className="flex items-center gap-15">
        <AdditionalTransportListOrderButton
          isDisabled={isDisabled}
          type="cheapest"
          isSelected={selectedOrder === 'cheapest'}
          setSelectedOrder={() => {
            setSelectedOrder('cheapest');
          }}
          price={
            cheapestTransport
              ? getTotalDifferentialPrice(cheapestTransport?.totalDifferentialPrice)
              : '0'
          }
          time={
            cheapestTransportTime > 0
              ? t('booking.transport.averageFlightDuration', {
                  time: transformMinutesInHours(
                    getTransportAverageDuration(cheapestTransport),
                    isRTL,
                  ),
                })
              : undefined
          }
        />
        <AdditionalTransportListOrderButton
          isDisabled={isDisabled}
          type="fastest"
          isSelected={selectedOrder === 'fastest'}
          setSelectedOrder={() => {
            setSelectedOrder('fastest');
          }}
          price={
            fastestTransport
              ? getTotalDifferentialPrice(fastestTransport?.totalDifferentialPrice)
              : '0'
          }
          time={
            fastestTransportTime > 0
              ? t('booking.transport.averageFlightDuration', {
                  time: transformMinutesInHours(
                    getTransportAverageDuration(fastestTransport),
                    isRTL,
                  ),
                })
              : undefined
          }
        />
      </div>
      <p className="mt-10 text-12 font-normal">{t('booking.transport.sort.label')}</p>
    </div>
  );
};
